import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

const PREFIX = "AdditionalFilterStack";
export const classes = {
  root: `${PREFIX}-root`,
  sectionTitle: `${PREFIX}-sectionTitle`,
};

export const AdditionalFilterStack = styled(Stack)(({ theme }) => ({
  [`&.${classes.root}`]: {
    flexDirection: "column",
    flexBasis: "100%",
    gap: theme.spacing(2),
    [`& .${classes.sectionTitle}`]: {
      color: theme.palette.primary.main,
      "&:first-letter": {
        textTransform: "uppercase",
      },
    },
  },
}));
